(function(){
  if (!document) return;

  function reflowMega(){
    document.querySelectorAll('.submenu.mega-menu .submenu-masonry').forEach(function(container){
      if (!container) return;

      // Keep mobile drawer menus as a vertical list (desktop mega columns only).
      if (container.closest('mobile-navigation') || container.closest('#site-menu-sidebar')) {
        container.style.removeProperty('--mega-cols');
        container.style.display = '';
        container.style.gridTemplateColumns = '';
        container.style.position = '';
        container.style.height = '';
        container.style.overflow = '';
        Array.prototype.forEach.call(container.children, function(li){
          if (!li) return;
          li.style.position = '';
          li.style.width = '';
          li.style.left = '';
          li.style.top = '';
          li.style.transform = '';
          li.style.opacity = '';
        });
        return;
      }

      var cols = parseInt(container.getAttribute('data-columns'), 10);
      if (!cols || cols < 1) {
        var linkCount = container.querySelectorAll(':scope > .mega-link:not(.has-promotion)').length;
        if (linkCount < 1) linkCount = container.children.length;
        cols = linkCount > 8 ? 8 : Math.max(linkCount, 1);
      }

      container.style.setProperty('--mega-cols', String(cols));
      container.style.display = 'grid';
      container.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
      container.style.position = 'static';
      container.style.height = 'auto';
      container.style.overflow = 'visible';

      Array.prototype.forEach.call(container.children, function(li){
        if (!li) return;
        li.style.position = 'static';
        li.style.width = 'auto';
        li.style.left = '';
        li.style.top = '';
        li.style.transform = '';
        li.style.opacity = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', reflowMega);
  setTimeout(reflowMega, 350);
  window.addEventListener('resize', function(){ setTimeout(reflowMega, 120); });

  var mo = new MutationObserver(function(){
    clearTimeout(window.__megaReflowTimeout);
    window.__megaReflowTimeout = setTimeout(reflowMega, 200);
  });
  mo.observe(document.body, {childList: true, subtree: true});
})();
